import { useState } from "react";
import moment from "moment";

function Luck() {
  const [opt, setOpt] = useState(null);

  const opts = [
    "ganhar um jantar romântico preparado pelo seu amor",
    "ganhar beijos pelo corpo todo",
    "ganhar um abraço bem apertado e quentinho",
    "tomar um banho com seu amor",
    "ganhar um café da manhã na cama preparado pelo seu amor",
    "assistir um filme com seu amor",
    "ganhar uma massagem relaxante",
    "fazer um piquenique com seu amor",
    "dormir agarradinha com seu amor",
    "jogar com seu amor",
    "cozinhar com seu amor",
  ];

  const sortOne = () => {
    setOpt(Math.floor(Math.random() * opts.length));

    if (moment().isSame("2025-06-12", "day")) {
      const interval = setInterval(() => {
        setOpt(0);
      }, 2100);

      return () => clearInterval(interval);
    }
  };

  return (
    <div
      id="luck"
      className="d-flex align-items-center justify-content-center text-center py-5"
    >
      <div className="container py-5">
        <h3 className="m-0">
          E falando em sorte, hoje é <b>seu</b> dia de sorte, porquê você vai...
        </h3>
        <div
          style={{ height: "200px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <h1 className="m-0">{opt === null ? "???????" : opts[opt]}</h1>
        </div>
        <button id="btn" type="button" onClick={sortOne}>
          Descobrir
        </button>
      </div>
    </div>
  );
}

export default Luck;
